<div class="modal fade" id="{{targetId}}"
     tabindex="-1"
     role="dialog"
     aria-label="Dialog-Info"
     aria-hidden="true"
     #modalDialogEl>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-header">
        <button type="button" id="updateHint-button-close-modal-dialog" class="ba-modal-close" data-bs-dismiss="modal" aria-label="Schließen"></button>
        <h1 id="{{targetId}}_Titel" class='modal-title ba-icon ba-icon-information modal-icon'>{{headerTitle}}</h1>
      </div>

      <div class="modal-body">
        <ng-content></ng-content>
      </div>

      <div class="modal-footer">
        <button
          class="ba-btn ba-btn-primary"
          type="button"
          aria-label="Schließen"
          data-bs-dismiss='modal'
          id="{{targetId}}_btn">
          Schließen
        </button>
      </div>
    </div>
  </div>
</div>
